import axios from "axios";
import env from "../variables/EndpointEnvironment";
const headers = {
  "Content-Language": localStorage.getItem('i18nextLng'),
}
const CardBukopinPrioritasAPI = (props) => {
 
  return axios.get(
    `${env.HOST}/solusi-keseharian-anda/prioritas`,
    {
      headers
    }
  );
};


export default CardBukopinPrioritasAPI;
